// extracted by mini-css-extract-plugin
export default {"spin-indicator":"eEan3","spinIndicator":"eEan3","spin":"LuunR"};